module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABCUlEQVQ4T+3UL0uDURTH8e9PEJbEsqAWjdalsTaMgiZNgvoGfDG+gW1g0uTAKDYxWY0mV2yCYPLII2fj7PHuXsMDFk+74Xw4nD9XZrYCXNNM7MvM1oBJMx7ragiaMb8CzeygypB0VSqgCDp26dBhCc2CAft0cAnIogvBgH0ADw52gVYOTYIBewNOgDMHz4EhUK1astIfYMBegVNJN2Z250Ppm9kuMADaKXQODNgLcCzptoIi6O8dYARs1NEZGLBn4EjS/XRF6qCjPeAC2IpoBA14cuwx7lsKdLTj6LakbyuCm8C7pKp3c7EIdHQVWJ7mFRc71cPctfyD6e7khlLP+LMejv309kr/4RdUCYo2Lizv5AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/backtop.png
// module id = 18
// module chunks = 2